import { nextLine } from "components/mlpaUiComponents/LegalNote/lib";

export default {
  accessPermissionManagement: "Access Permission Management",
  table: {
    column: {
      certificateName: "Certificate Number",
      requestedOn: "Requested On",
      tenantName: "Tenant Name",
      tenantRole: "Tenant Role",
      status: "Status",
      accessRequestedTo: "Requested Access To",
      typeOfRequestedData: "Type of Requested Data",
      approvedBy: "Approved/Denied By",
      approvedOn: "Approved/Denied On",
      requestToTenant: "Requested To",
      requestedBy: "Requested By",
    },
  },
  gridConnectionValues: "Grid Connection Values",
  matrixParameters: "Matrix Parameters",
  inertiaParameters: "Inertia Parameters",
  openRequest: "open request",
  buttons: {
    approveRequest: "Approve Request(s)",
    denyRequest: "Deny Request(s)",
  },
  modal: {
    approveTitle: "Approve Request(s)",
    denyTitle: "Deny Request(s)",
    approveBody: `Are you sure you want to approve this/these access request(s)?${nextLine()}Once approved, user(s) of the tenant(s) will gain access to the data. Access can be revoked at any time if needed.`,
    denyBody: `Are you sure you want to deny this/these access request(s)?${nextLine()}The requesting user(s) will be informed of your decision via email. They can submit a new access request at any time if needed.`,
    confirmApprove: "approve request(s)",
    confirmDeny: "deny request(s)",
  },
  filters: {
    status: "Status",
    typeOfRequestedData: "Type of Requested Data",
  },
  tabs: {
    accessRequests: "Access Requests",
    generalAccessGrants: "General Access Grants",
  },
  subTabs: {
    fileVisibility: "Custom File Visibility",
    parameterVisibility: "Unit & Matrix Parameter Visibility",
  },
  fileVisibility: {
    title: "Custom File Visibility Grants",
    noData: "No files with custom visibility grants found.",
    table: {
      fileName: "File Name",
      certificateNumber: "Certificate Number",
      fileType: "File Type",
      visibleToRoles: "Visible to Roles",
      visibleToTenants: "Visible to Tenants",
      modifiedAt: "Modified At",
    },
    buttons: {
      editVisibility: "Edit Visibility",
      revokeVisibility: "Revoke Visibility",
    },
    modal: {
      revokeTitle: "Revoke File Visibility",
      revokeBody:
        "Are you sure you want to revoke the custom visibility for the selected file(s)? The file(s) will no longer be visible to the specified roles/tenants.",
      confirmRevoke: "Revoke Visibility",
      editTitle: "Edit File Visibility",
      editBody: "Configure visibility grants for this file. Select at least one role or tenant.",
      confirmEdit: "Save Changes",
      roleSelection: "Grant access to roles",
      tenantSelection: "Grant access to tenants",
      searchTenants: "Search for organizations...",
      searchMinCharacters: "Type at least 2 characters to search",
      validationError: "Please select at least one role or tenant",
    },
  },
  parameterVisibility: {
    title: "Unit & Matrix Parameter Visibility Grants",
    noData: "No units with parameter visibility grants found.",
    table: {
      modelName: "Model Name",
      modelNumber: "Model Number",
      parameterType: "Parameter Type",
      visibleToRoles: "Visible to Roles",
      visibleToTenants: "Visible to Tenants",
      modifiedAt: "Modified At",
    },
    buttons: {
      editVisibility: "Edit Visibility",
      revokeVisibility: "Revoke Visibility",
    },
    modal: {
      revokeTitle: "Revoke Parameter Visibility",
      revokeBody:
        "Are you sure you want to revoke the parameter visibility for the selected unit(s)? The parameters will no longer be visible to the specified roles/tenants.",
      confirmRevoke: "Revoke Visibility",
      editTitle: "Edit Parameter Visibility",
      editBody: "Configure visibility grants for this parameter. Select at least one role or tenant.",
      confirmEdit: "Save Changes",
      roleSelection: "Grant access to roles",
      tenantSelection: "Grant access to tenants",
      searchTenants: "Search for organizations...",
      searchMinCharacters: "Type at least 2 characters to search",
      validationError: "Please select at least one role or tenant",
    },
  },
};
